import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTypesTrain = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.36793 29.0576L10.771 25.8827L11.7522 24.365H23.9911L25.256 25.8827L27.6624 29.0576C27.8315 29.3353 27.8606 29.6559 27.7434 29.9509C27.6261 30.2458 27.3719 30.4916 27.0351 30.6356C26.6983 30.7796 26.3057 30.8105 25.9413 30.7215C25.577 30.6325 25.2699 30.4307 25.0858 30.1595L24.2781 29.1828H11.7522L10.9445 30.1595C10.8583 30.301 10.7383 30.427 10.5915 30.5302C10.4447 30.6333 10.2742 30.7116 10.0898 30.7603C9.9054 30.809 9.71095 30.8272 9.51783 30.8138C9.32471 30.8004 9.13682 30.7557 8.96519 30.6823C8.79356 30.6089 8.64164 30.5083 8.51836 30.3864C8.39508 30.2645 8.30291 30.1237 8.24728 29.9724C8.19164 29.821 8.17365 29.6621 8.19437 29.5051C8.21509 29.348 8.2741 29.1959 8.36793 29.0576Z",
			fill: "url(#paint0_linear_10904_1640)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9736 27.2866L14.0083 25.9453H22.0184L23.0531 27.2866H12.9736Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99674 8.949C9.1982 7.10718 10.6383 5.63173 12.4829 5.45768C16.4022 5.08786 19.4856 5.08989 23.5052 5.46422C25.3553 5.63651 26.8027 7.11335 27.0047 8.96042L28.3522 21.28C28.5494 23.0831 27.5043 24.7876 25.7454 25.2306C23.7488 25.7334 20.922 26.2616 17.8571 26.2616C14.824 26.2616 12.1008 25.7443 10.1821 25.2462C8.45557 24.798 7.44709 23.1169 7.64103 21.3437L8.99674 8.949Z",
			fill: "url(#paint1_linear_10904_1640)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 4.7883,
			y: 5.55075,
			width: 26.4234,
			height: 16.9131,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(2.67px)",
					clipPath: "url(#bgblur_0_10904_1640_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 5.34354,
			x: 10.1318,
			y: 10.8943,
			width: 15.7363,
			height: 6.22609,
			rx: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.8423,
			cy: 21.4307,
			r: 1.71045,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24.1577,
			cy: 21.4307,
			r: 1.71045,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14.75,
			y: 7.47339,
			width: 6.5,
			height: 1.71046,
			rx: .855232,
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_10904_1640_clip_path",
				transform: "translate(-4.7883 -5.55075)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 10.1318,
					y: 10.8943,
					width: 15.7363,
					height: 6.22609,
					rx: 1
				})
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_10904_1640",
				x1: 18.0001,
				y1: 24.365,
				x2: 18.0001,
				y2: 30.818,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#25A0F3" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .53125,
						stopColor: "#038AE4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#0380D5"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_10904_1640",
				x1: 15.6623,
				y1: 5.18189,
				x2: 24.3212,
				y2: 26.2616,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#53B1F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0393F4"
				})]
			})
		] })
	]
});
export default SvgTypesTrain;
